module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path == '/AgentOrder/AgentOrder') ? _c('div', [_c('el-form', {
    staticClass: "toolbar",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售下单号:",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.OrderCode),
      callback: function($$v) {
        _vm.$set(_vm.query, "OrderCode", $$v)
      },
      expression: "query.OrderCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出库单号:",
      "label-width": "90px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.OutCode),
      callback: function($$v) {
        _vm.$set(_vm.query, "OutCode", $$v)
      },
      expression: "query.OutCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物流单号:",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.LogCode),
      callback: function($$v) {
        _vm.$set(_vm.query, "LogCode", $$v)
      },
      expression: "query.LogCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出库单状态:",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    staticClass: "formlength",
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.query.Status),
      callback: function($$v) {
        _vm.$set(_vm.query, "Status", $$v)
      },
      expression: "query.Status"
    }
  }, _vm._l((_vm.queryType), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.TypeValue,
        "label": option.TypeName
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货状态:",
      "label-width": "90px"
    }
  }, [_c('el-select', {
    staticClass: "formlength",
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.query.ReceivingStatus),
      callback: function($$v) {
        _vm.$set(_vm.query, "ReceivingStatus", $$v)
      },
      expression: "query.ReceivingStatus"
    }
  }, _vm._l((_vm.queryDelivery), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.TypeValue,
        "label": option.TypeName
      }
    })
  }))], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.onQuerySubmit
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "delete2"
    },
    on: {
      "click": _vm.onQueryClean
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading2),
      expression: "loading2"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists,
      "element-loading-text": "拼命加载中",
      "border": "",
      "router": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "出库单号",
      "prop": "StockOutCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "销售下单时间",
      "prop": "OrderTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "业务员",
      "prop": "SaleEmployeeName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实际发货时间",
      "prop": "StockOutTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实际签收时间",
      "prop": "SignTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流单号",
      "prop": "LogisticsCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出库单状态",
      "prop": "StatusName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "收货状态",
      "prop": "ReceivingStatusName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "view",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.handleView(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "icon": "menu",
            "disabled": (scope.row.btnVue & 1024) <= 0,
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.harvest(scope.row)
            }
          }
        }, [_vm._v("收货")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "收货",
      "size": "tiny"
    },
    model: {
      value: (_vm.SaleCheckView),
      callback: function($$v) {
        _vm.SaleCheckView = $$v
      },
      expression: "SaleCheckView"
    }
  }, [_c('el-row', [_c('div', [_c('div', [_vm._v("商品")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.GoodsList.ListGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SendNum",
      "label": "总数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ActualNum",
      "label": "实发"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实收",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "display": "flex",
            "align-items": "center"
          },
          attrs: {
            "size": "small",
            "min": 0,
            "max": scope.row.ActualNum
          },
          model: {
            value: (scope.row.ProNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ProNum", $$v)
            },
            expression: "scope.row.ProNum"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.GoodsList.GiftGoods != ''),
      expression: "GoodsList.GiftGoods!=''"
    }]
  }, [_c('div', [_vm._v("赠品")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.GoodsList.GiftGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SendNum",
      "label": "总数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ActualNum",
      "label": "实发"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实收",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "display": "flex",
            "align-items": "center"
          },
          attrs: {
            "size": "small",
            "min": 0,
            "max": scope.row.ActualNum
          },
          model: {
            value: (scope.row.ProNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ProNum", $$v)
            },
            expression: "scope.row.ProNum"
          }
        })]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-row'), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "-20px",
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sumbitGoods
    }
  }, [_vm._v("确定收货")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "反馈"
    },
    model: {
      value: (_vm.feedbackCheckView),
      callback: function($$v) {
        _vm.feedbackCheckView = $$v
      },
      expression: "feedbackCheckView"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.AddForm.ReceiveType),
      callback: function($$v) {
        _vm.$set(_vm.AddForm, "ReceiveType", $$v)
      },
      expression: "AddForm.ReceiveType"
    }
  }, _vm._l((_vm.QueryTypeList), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ParmName))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传签收单"
    }
  }, [_c('div', {
    attrs: {
      "id": "container1"
    }
  }, [_vm._l((_vm.PictureList), function(item) {
    return _c('div', {
      staticClass: "ImgPrev"
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image myProPic",
      attrs: {
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.viewPicture(item.Url)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticStyle: {
        "width": "10px",
        "padding": "6px"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delPicture(item.Url)
        }
      }
    })])])])])])
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullPicture2),
      expression: "!fullPicture2"
    }],
    staticStyle: {
      "width": "80px",
      "height": "80px",
      "float": "left"
    },
    attrs: {
      "icon": "plus",
      "id": "btn1"
    }
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传其他图片"
    }
  }, [_c('div', {
    attrs: {
      "id": "container2"
    }
  }, [_vm._l((_vm.otherPictureList), function(item) {
    return _c('div', {
      staticClass: "ImgPrev"
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image myProPic",
      attrs: {
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.viewPicture(item.Url)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticStyle: {
        "width": "10px",
        "padding": "6px"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delPicture(item.Url, 'del')
        }
      }
    })])])])])])
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullPicture),
      expression: "!fullPicture"
    }],
    staticStyle: {
      "width": "80px",
      "height": "80px",
      "float": "left"
    },
    attrs: {
      "icon": "plus",
      "id": "btn2"
    }
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.AddForm.CustomerRemark),
      callback: function($$v) {
        _vm.$set(_vm.AddForm, "CustomerRemark", $$v)
      },
      expression: "AddForm.CustomerRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "-20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.feedBackSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1) : _c('div', [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e636d9ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Agent/AgentOrder.vue
// module id = 1575
// module chunks = 1